module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('app-header'), _vm._v(" "), _c('nav', {
    staticClass: "nav-home wrap"
  }, [(_vm.actions.length > 0) ? _c('a', {
    staticClass: "btn sync sml",
    attrs: {
      "id": "btn-offline"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.trySync('synchro')
      }
    }
  }, [_c('i', {
    staticClass: "actions"
  }, [_vm._v(_vm._s(_vm.actions.length))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Actions")]), _vm._v("\n              Non synchronisées\n            ")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-sync"
  })]) : _vm._e(), _vm._v(" "), (_vm.actions.length <= 0) ? _c('a', {
    staticClass: "btn sync sml",
    attrs: {
      "id": "btn-sync"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.trySync('init')
      }
    }
  }, [_c('span', [_c('strong', [_vm._v("Synchroniser")]), _vm._v("\n              Les données\n            ")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-sync"
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 'technicien') ? _c('span', {
    staticClass: "if"
  }, [_c('router-link', {
    staticClass: "btn sync",
    attrs: {
      "id": "btn-interventions",
      "to": "liste-fibsdd"
    }
  }, [_c('i', {
    staticClass: "icon-tools"
  }), _vm._v(" "), (this.numberFibsdd() > 0) ? _c('i', {
    staticClass: "actions",
    staticStyle: {
      "z-index": "1"
    }
  }, [_vm._v(_vm._s(this.numberFibsdd()))]) : _vm._e(), _vm._v(" "), _c('span', [_c('strong', {
    staticStyle: {
      "z-index": "1"
    }
  }, [_vm._v("Intervention" + _vm._s(this.numberFibsdd() > 1 ? 's' : ''))])]), _vm._v(" "), _c('i', {
    staticClass: "icon-go"
  })]), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "id": "btn-contrat",
      "to": "contrat-assemblage"
    }
  }, [_c('i', {
    staticClass: "icon-contract"
  }), _vm._v(" "), _c('span', [_vm._v("\n                        Contrat"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("d'assemblage")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "id": "btn-interventions-d",
      "to": "ctrl-multi"
    }
  }, [_c('i', {
    staticClass: "icon-tools"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Controles d'étanchéité")]), _vm._v("\n                        périodiques  - multiples\n                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    class: {
      sml: _vm.type !== 'technicien'
    },
    attrs: {
      "id": "btn-detenteurs",
      "to": "liste-detenteurs"
    }
  }, [_c('i', {
    staticClass: "icon-factory"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Détenteurs")]), _vm._v("\n              & installations\n            ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-go"
  })]), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn sml",
    attrs: {
      "id": "btn-bouteilles",
      "to": "liste-bouteilles"
    }
  }, [_c('i', {
    staticClass: "icon-gas"
  }), _vm._v(" "), _c('span', [_vm._v("Bouteilles")])]), _vm._v(" "), (_vm.type === 'technicien') ? _c('router-link', {
    staticClass: "btn sml",
    attrs: {
      "id": "btn-outils",
      "to": "liste-outils"
    }
  }, [_c('i', {
    staticClass: "icon-tool"
  }), _vm._v(" "), _c('span', [_vm._v("Outillage")])]) : _vm._e()], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.token),
      expression: "token"
    }],
    staticClass: "btn tutobtn",
    attrs: {
      "target": "_blank",
      "href": ("https://admin.fi360.fr/tutorials?token=" + _vm.token)
    }
  }, [_c('span', [_c('strong', [_vm._v("TUTORIELS")]), _vm._v("\n                F.i360°\n            ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-go"
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "btn-support"
    },
    on: {
      "click": _vm.openSupport
    }
  }, [_vm._v("\n                Support\n                "), (_vm.badgeCount > 0) ? _c('div', {
    staticClass: "indicator"
  }, [_c('div', {
    staticClass: "noti_count",
    attrs: {
      "role": "status"
    }
  }, [_vm._v(_vm._s(_vm.badgeCount))])]) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bc07a34","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Home.vue
// module id = 747
// module chunks = 0